export const obj = {
    setAll (state, array) {
        state.list = array
    },

    setLoading (state, boolean) {
        state.isLoading = boolean
    },

    setPagination (state, obj) {
        if (obj.meta){
            obj = obj.meta
        }
        if (obj.data && !obj.current_page){
            obj = obj.data
        }

        const pageInt = obj.current_page ? parseInt(obj.current_page) : parseInt(obj.page)
        state.pagination = {
            per_page: parseInt(obj.per_page),
            page: pageInt,
            total: parseInt(obj.total)
        }
    },

    setCurrent (state, obj) {
        state.current = obj
    }
}

export default function makeMutations() {
    return Object.assign({}, obj)
}